export default "__VITE_ASSET__CxwP2JUL__"